import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cookies, withCookies } from 'react-cookie';
import { withTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import { fetchCourseOptionsAction } from '../../../../store/pricingDucks/courseOptions';
import { clearBasketAction } from '../../../../store/pricingDucks/chosenProducts';
import { canCookieBeSecure } from '../../../../helpers';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import SelectCourseOptionForm from '../../../payments/SelectCourseOptionForm/SelectCourseOptionForm';
import OrderExpiredView from '../../paymentJourney/OrderExpiredView/OrderExpiredView';
import { withPaymentJourney } from '../../paymentJourney/hocs/withPaymentJourney/withPaymentJourney';

export class SelectCourseOptionView extends Component {
  fetchCourseOptions(basketId) {
    this.props.fetchCourseOptions(basketId);
  }

  onClearBasket = () => {
    const { pageConfig: { cookieSitePath } = {} } = this.props;
    const basketId = uuid();

    this.props.clearBasket();

    this.props.cookies.set('basket_id', basketId, {
      path: cookieSitePath,
      expires: new Date(Date.now() + 86400000),
      secure: canCookieBeSecure(),
    });

    this.fetchCourseOptions(basketId);
  };

  render() {
    const {
      courseOptions: {
        statusCode,
        data: { options = [], description, multiCurrency } = {},
      } = {},
      siteHeader: { meta: { title } = {} } = {},
      options: { data: { deliveryType } = {} } = {},
      t,
    } = this.props;

    if (statusCode === 410) {
      return <OrderExpiredView />;
    }

    return (
      <SiteLayout
        footerUpperHidden
        helmet={{
          title: `${t('site.purchase.select-option-title')} | ${title}`,
        }}
      >
        <SelectCourseOptionForm
          courseOptions={options}
          description={description}
          onClearBasket={this.onClearBasket}
          deliveryType={deliveryType}
          isMultiCurrency={multiCurrency}
        />
      </SiteLayout>
    );
  }
}

SelectCourseOptionView.propTypes = {
  courseOptions: PropTypes.shape({
    data: PropTypes.object,
  }),
  siteHeader: PropTypes.object,
  options: PropTypes.object,
  cookies: PropTypes.instanceOf(Cookies),
};

function mapStateToProps(state) {
  return {
    courseOptions: state.courseOptions,
    siteHeader: state.siteHeader,
    pageConfig: state.pageConfig,
    options: state.options,
    booking: state.courseOptions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchCourseOptions(basketId) {
      return dispatch(fetchCourseOptionsAction(basketId));
    },
    clearBasket() {
      return dispatch(clearBasketAction());
    },
  };
}

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withRouter(withPaymentJourney(withCookies(SelectCourseOptionView)))),
);
